import { atom } from 'recoil';
import {} from '../model/user.dto';

export const searchIdRecoil = atom<string>({
  key: 'searchIdRecoil',
  default: '',
});

export const searchPasswordRecoil = atom<string>({
  key: 'searchPasswordRecoil',
  default: '',
});

export const tokenTriggerRecoil = atom<boolean>({
  key: 'tokenTriggerRecoil',
  default: false,
});

export const accessTokenRecoil = atom<string>({
  key: 'accessTokenRecoil',
  default: '',
});

export const refreshTokenRecoil = atom<string>({
  key: 'refreshTokenRecoil',
  default: '',
});
